export default {
  institution: {
    tabs: {
      info: "General information",
      general_info: "General information",
      stats: "Statistics",
    },
    list: "View the list of institutions",
    dashboardLink: "Go to the institution's dashboard",
    active: "Active",
    archived: "Archived",
    training_active: "Active",
    training_archived: "Archived",
    view: "View",
    view_training: ({ named }) => `View training ${named("name")}`,
    no_trainings: "No training",
    avatar_alt: ({ named }) => `Logo of ${named("name")}`,
    avatar_initials_alt: ({ named }) => `Initials of ${named("name")}`,
    fields: {
      logo: "Logo",
      name: "Name",
      siret: "SIRET",
      code_uai: "UAI code",
      email: "Email",
      phone: "Phone",
      address: "Address",
      url: "Website",
      account_number: "Account number",
      status: "Status",
    },
    components: {
      title: "Components",
    },
    contacts: {
      title: "Contacts",
      empty: "No linked contact",
      unknown_role: "Contact",
      account_active: "Active account",
      account_inactive: "Inactive account",
    },
    stats: {
      coming_soon: "Coming soon",
      export_all_excel: "Export all — Excel",
      export_in_progress: "Export in progress — you will be notified when it is ready",
      export_failed: "Export failed.",
      level: {
        danger: "Low level",
        warning: "Medium level",
        success: "Good level",
      },
      calculation_note:
        "<strong>Statistics calculation</strong>: rates calculated on published and non-archived questionnaires." +
        " A triad is complete when all 3 profiles (apprentice, tutor, academic supervisor) have access to the booklet.",
      table: {
        caption: "Statistics by training",
        training: "Training",
        questionnaires: "Questionnaires",
        skills: "Skills",
        connections: "Connections",
        triads: "Triads",
      },
      indicators: {
        questionnaire_fill_rate: "Questionnaire completion rate",
        skill_fill_rate: "Skills completion rate",
        user_connection_rate: "User connection rate",
        completed_triads_rate: "Completed triads rate",
      },
      subcounts: {
        promotions: "promotion(s)",
        active_users: "active users",
        triads: "triad(s)",
      },
    },
    key_figures: {
      title: "Key figures",
      current_year: ({ named }) => `Current year ${named("start")}/${named("end")}`,
      tooltip: "Calculated on promotions including the current year",
    },
    trainings_count: ({ plural }) => plural(["training", "trainings"]),
    promotions_count: ({ plural }) => plural(["promotion", "promotions"]),
    apprentices_count: ({ plural }) => plural(["apprentice", "apprentices"]),
    active_trainings_count: ({ plural }) => plural(["active training", "active trainings"]),
    current_promotions_count: ({ plural }) => plural(["current promotion", "current promotions"]),
    tutors_count: ({ plural }) => plural(["company tutor", "company tutors"]),
  },
};
